<template>
  <div class="border rounded h-100">
    <b-row>
      <b-col>
        <div class="breadcrumbs bg-light-gray p-2">
          <span>
            <span
              :class="currentPath ? 'hover-pointer' : ''"
              :style="{ color: currentPath ? '#2196F3' : '#646A7A' }"
              @click="resetPath"
            >
              Group Types
            </span>
            <span class="color-custom-dark-grey ml-1 mr-1">/ </span>
          </span>
          <span
            v-for="(pathItem, pathItemIndex) in selectedPath"
            :key="pathItem.id"
          >
            <span
              v-if="
                pathItemIndex != selectedPath.length - 1 || selectedGroupType
              "
              :class="currentPath ? 'hover-pointer' : ''"
              :style="{ color: currentPath ? '#2196F3' : '#646A7A' }"
              @click="goToPathItem(pathItem.id)"
              >{{ pathItem.type }}
            </span>
            <span v-else class="color-custom-dark-grey">{{
              pathItem.type
            }}</span>
            <span class="color-custom-dark-grey ml-1 mr-1">/ </span>
          </span>
          <span v-if="selectedGroupType" class="color-custom-dark-grey">{{
            selectedGroupType.type
          }}</span>
        </div>
      </b-col>
    </b-row>
    <b-row style="height: calc(100% - 39px);">
      <b-col class="h-100">
        <div class="group-types p-2 h-100" style="overflow-y: auto;">
          <div class="d-flex align-items-center mt-1 mb-2">
            <i
              class="fas fa-arrow-left p-1"
              :class="currentPath ? 'hover-pointer' : ''"
              :style="{ color: currentPath ? '#2196F3' : '#B9B9B9' }"
              @click="back"
            ></i>
            <span class="ml-2">
              {{ currentPath ? currentPath.type : "Group Types" }}
            </span>
          </div>
          <div class="flex-grow-1 mt-1">
            <div v-if="selectedItem" class="border rounded h-100">
              <div class="bg-light-gray border-bottom p-2">
                Description
              </div>
              <b-form-textarea
                class="group-type-details"
                :value="details"
                @input="$emit('change-details', $event)"
              />
            </div>
            <div v-else>
              <group-session-type-picker-tree
                :items="tree"
                :selectedPath="selectedPath"
                @push-path="pushPath"
                @select-item="selectItem"
                :selectedFolder="selectedPath.length == 0"
                :selectedItem="selectedItem"
                :level="0"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import groupSessionTypeServer from "../../server/groupSessionType";
import GroupSessionTypePickerTree from "./GroupSessionTypePickerTree.vue";

const buildTree = (list, rootId) => {
  let tree = [];
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    if (item.parentId == rootId) {
      let treeItem = {
        item: item,
        subItems: buildTree(list, item.id)
      };
      tree.push(treeItem);
    }
  }
  tree.sort((a, b) => {
    if (a.subItems.length > 0 && b.subItems.length > 0)
      return a.item.type.localeCompare(b.item.type);
    if (a.subItems.length > 0) return -1;
    if (b.subItems.length > 0) return 1;
    return a.item.type.localeCompare(b.item.type);
  });
  return tree;
};

const buildPath = (list, item) => {
  let path = [item];
  for (let index = 0; index < list.length; index++) {
    const parent = list[index];
    if (parent.id == item.parentId) {
      path = [...buildPath(list, parent), item];
    }
  }
  return path;
};

export default {
  name: "GroupSessionTypePicker",
  components: { GroupSessionTypePickerTree },
  props: ["topicId", "details"],
  data() {
    return {
      groupTypes: [],
      selectedPath: [],
      selectedItem: null
    };
  },
  async mounted() {
    await this.getGroupTypes();
    this.getPathData();
  },
  methods: {
    async getGroupTypes() {
      this.groupTypes = await groupSessionTypeServer.query();
    },
    resetPath() {
      this.selectedPath = [];
      this.selectItem(null);
    },
    pushPath(item) {
      const newPath = this.selectedPath;
      newPath.push(item);
      this.selectedPath = newPath;
      this.selectItem(null);
    },
    selectItem(item) {
      this.selectedItem = item;
      this.$emit("change-details", item ? item.details : "");
      this.$emit("change-group-type", item ? item.id : null);
    },
    goToPathItem(pathItemId) {
      const newPath = [];
      for (let index = 0; index < this.selectedPath.length; index++) {
        const pathItem = this.selectedPath[index];
        newPath.push(pathItem);
        if (pathItem.id == pathItemId) break;
      }
      this.selectedPath = newPath;
      this.selectItem(null);
    },
    getPathData() {
      if (this.topicId) {
        const groupType = this.groupTypes.find(gT => gT.id == this.topicId);
        if (groupType && groupType.parentId) {
          const groupTypeParent = this.groupTypes.find(
            gT => gT.id == groupType.parentId
          );
          this.selectedPath = buildPath(this.groupTypes, groupTypeParent);
        }
        this.selectedItem = groupType;
      }
    },
    back() {
      if (!this.currentPath) {
        return;
      }
      if (this.selectedItem) {
        const pathItem = this.selectedPath[this.selectedPath.length - 1];
        this.goToPathItem(pathItem?.id);
      } else {
        if (this.selectedPath.length === 1) {
          this.resetPath();
          return;
        }
        const pathItem = this.selectedPath[this.selectedPath.length - 2];
        this.goToPathItem(pathItem?.id);
      }
    }
  },
  computed: {
    tree() {
      return buildTree(this.groupTypes, null);
    },
    selectedGroupType() {
      const groupType = this.groupTypes.find(gT => gT.id == this.topicId);
      return groupType;
    },
    currentPath() {
      if (this.selectedGroupType) {
        return this.selectedGroupType;
      }
      if (this.selectedPath.length) {
        return this.selectedPath[this.selectedPath.length - 1];
      }
      return null;
    }
  },
  watch: {
    topicId() {
      this.getPathData();
    }
  }
};
</script>

<style scoped>
.group-types {
  display: flex;
  flex-direction: column;
}

.breadcrumbs {
  font-size: 14px;
  min-height: 37px;
}
.no-group {
  height: 100%;
}
.group-type-details {
  resize: none;
  border: none;
  height: calc(100% - 42px);
  font-size: 13px;
}
</style>

<style>
.no-group > div {
  height: 100%;
}
</style>
